import { useState } from "react";
import { useDispatch } from "react-redux";

import { Item } from "../../redux/shop/shop.types";
import { cartActions } from "../../redux/cart/cart.reducer";

import useStyles from "./clear-item-in-cart.styles";
import { Link } from "react-router-dom";

const ClearItemInCart = ({
  item,
  setClearing,
  clearItemFromCart,
}: {
  item: any;
  setClearing: any;
  clearItemFromCart: any;
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles({ open });

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.container}>
      <button onClick={handleOpen} className={classes.openBtn}>
        Remove
      </button>
      <div className={classes.content} onClick={handleClose}>
        <div>Are you sure you want to remove this item?</div>
        <div className={classes.btns}>
          <div
            className={classes.btn}
            onClick={() => {
              clearItemFromCart(item);
              setClearing(true);
            }}
          >
            Remove
          </div>
          <div className={classes.btn} onClick={handleClose}>
            Cancel
          </div>
        </div>
        <Link
          className={classes.link}
          to={`/shop/product?collectionId=${item.collectionId}&productId=${
            item.sk.includes("PROD") ? item.sk : item.pk.split("#")[1]
          }`}
        >
          Go to the Product Page
        </Link>
      </div>
    </div>
  );
};

export default ClearItemInCart;
